import { X, Check } from 'lucide-react';

const comparisons = [
  {
    without: '$200–$600 service call for a 20-minute fix',
    with: 'AI-guided diagnosis — fix it yourself',
  },
  {
    without: '40+ minutes on hold with the manufacturer',
    with: 'Manufacturer playbook — know exactly what to say',
  },
  {
    without: '2+ weeks waiting for a service tech',
    with: 'Same-day async support from a real expert',
  },
  {
    without: 'Members cancel over broken equipment',
    with: 'PM calendar prevents breakdowns before they happen',
  },
  {
    without: '$2,400+/year in preventable repair costs',
    with: 'Equipment dashboard catches issues early',
  },
];

export default function ValueStack() {
  return (
    <section className="py-10 md:py-14 px-4 relative overflow-hidden">
      {/* Gym background — cardio equipment */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1540497077202-7c8a3999166f?w=1920&q=80")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.14,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#161b26]/80 via-transparent to-[#161b26]/80" />

      <div className="relative z-10 max-w-4xl mx-auto">
        <div className="text-center mb-6 md:mb-8">
          <h2 className="text-xl md:text-3xl font-extrabold mb-2">
            The real cost of doing it alone
          </h2>
          <p className="text-white/40 text-xs md:text-sm">What changes when you have AthnxGym in your corner.</p>
        </div>

        {/* Desktop: side by side. Mobile: stacked pairs */}
        <div className="space-y-2">
          {/* Column headers — desktop only */}
          <div className="hidden md:grid md:grid-cols-2 gap-3 px-1 pb-1">
            <p className="text-xs font-semibold text-amber-400/70 uppercase tracking-wider">Without AthnxGym</p>
            <p className="text-xs font-semibold text-blue-400/70 uppercase tracking-wider">With AthnxGym</p>
          </div>

          {comparisons.map((item, i) => (
            <div key={i} className="grid md:grid-cols-2 gap-2">
              <div className="flex items-start gap-3 px-4 py-3 rounded-lg bg-amber-500/5 border border-amber-500/10 hover:bg-amber-500/10 transition-colors">
                <X className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
                <p className="text-white/60 text-sm">{item.without}</p>
              </div>
              <div className="flex items-start gap-3 px-4 py-3 rounded-lg bg-blue-500/5 border border-blue-500/10 hover:bg-blue-500/10 transition-colors">
                <Check className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
                <p className="text-white/80 text-sm">{item.with}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <div className="inline-block px-6 py-4 rounded-xl border border-blue-500/30 bg-blue-500/10 backdrop-blur-sm hover:scale-[1.02] transition-transform">
            <p className="text-white/50 text-xs mb-1">Total value prevented annually</p>
            <p className="text-3xl font-extrabold text-white">$4,000–5,000</p>
            <p className="text-blue-400 font-semibold text-sm mt-1">Your price: $99/month</p>
          </div>
        </div>
      </div>
    </section>
  );
}
